import { BETTO_ALERT_VARIANTS } from "./bettoAlertVariants";

const DEFAULT_ALERT_TITLES = {
	success: "SUCCESS",
	error: "ERROR",
	info: "ERROR",
};

const VARIANT_ALERT_TITLES = {
	"login-required": "LUCKY_BOX_MOBILE",
	"low-wallet-balance": "LUCKY_BOX_MOBILE",
	"session-expire": "SECURITY",
	"profile-update-required": "PROFILE_UPDATE_REQUIRED_TITLE",
};

const LEGACY_MSG_VARIANT_MAP = {
	LOGIN_FIRST: "login-required",
	DEPOSIT_SUCCESS_TITLE: "deposit-completed",
	"limits.runtime.depositExceeded": "insufficient-funds",
	SUCCESSFULL_UPLOAD: "verification-complete",
};

export const buildMsgVariantMap = () => {
	const map = { ...LEGACY_MSG_VARIANT_MAP };

	Object.entries(BETTO_ALERT_VARIANTS).forEach(([variantKey, config]) => {
		if (config.fallbackMsgKey) {
			map[config.fallbackMsgKey] = variantKey;
		}

		config.fallbackMsgKeys?.forEach((msgKey) => {
			map[msgKey] = variantKey;
		});
	});

	return map;
};

export const MSG_VARIANT_MAP = buildMsgVariantMap();

export const buildBettoAlertPayload = (variantKey, overrides = {}) => {
	const config = BETTO_ALERT_VARIANTS[variantKey];

	if (!config) {
		return null;
	}

	const msg = overrides.msg ?? config.fallbackMsgKey ?? config.fallbackMsgKeys?.[0];
	const title =
		overrides.title ??
		VARIANT_ALERT_TITLES[variantKey] ??
		DEFAULT_ALERT_TITLES[config.type] ??
		"ERROR";

	return {
		type: config.type,
		bettoVariant: variantKey,
		...(msg ? { msg } : {}),
		title,
		...overrides,
	};
};
